import { PayloadAction } from '@reduxjs/toolkit'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects'
import personalPanelAssignmentsActions, {
  personalPanelAssignmentsRequest,
} from '../../../actions/personalPanel/fetchAssignments'
import { ViewConstants } from '../../../actions/views/viewConstants'
import { ensureViewStateExists } from '../../entityDataByView/ensureViewStateExists'
import { coordinateAssignmentFetches } from '../coordinateAssignmentFetches'

export type FetchAssignmentsPayload = {
  viewKey?: string
  assignmentParams: Record<string, any>
  phaseItemParams: Record<string, any>
}

type Yield = CallEffect | PutEffect
type Return = void
type Next = void

export function* fetchAssignmentsFlow(
  action: PayloadAction<FetchAssignmentsPayload>
): Generator<Yield, Return, Next> {
  const { viewKey, phaseItemParams, assignmentParams } = action.payload

  try {
    yield call(ensureViewStateExists, ViewConstants.personalPanel)

    yield call(coordinateAssignmentFetches, {
      view: ViewConstants.personalPanel,
      viewKey,
      assignmentParams,
      phaseItemParams,
    })

    yield put(
      personalPanelAssignmentsActions.assignmentsFetchSuccess({ viewKey })
    )
  } catch (error) {
    if (error === undefined || typeof error === 'string') {
      yield put(
        personalPanelAssignmentsActions.assignmentsFetchError({
          viewKey,
          error,
        })
      )
    }
  }
}

export function* fetchAssignmentsSaga(): Generator<ForkEffect, void, void> {
  yield takeEvery(personalPanelAssignmentsRequest, fetchAssignmentsFlow)
}

export default [fetchAssignmentsSaga]
